import Paths from '../../config/paths';

export const headerTabsData = [
  {
    label: 'home',
    iconName: 'home',
    pathname: Paths.content.home,
  },
  {
    label: 'favorite',
    iconName: 'myNews',
    pathname: Paths.content.favorite,
  },
  {
    label: 'voiceSearch',
    iconName: 'logoChar',
    isMainIcon: true,
    pathname: Paths.content.genioChat,
  },
  {
    label: 'myNotes',
    iconName: 'notes',
    pathname: Paths.content.notes,
  },
  {
    label: 'profile',
    iconName: 'profile',
    pathname: Paths.content.profile,
  },
];
